<script>
	import marked from 'marked'
	import hljs from 'highlight.js'

	export default {
		name: 'sample-solution',
		data: () => ({
			solution: null,
      isCollapsed: true,
		}),


    async created() {
      const TOKEN = '2e0dd4ce9ce8595d76b32f0252f6379d2c5903ca'
			const res = await fetch(`/api2/solution?token=${TOKEN}`)
      const { solution } = await res.json()

      marked.setOptions({
        langPrefix:'hljs ',
        highlight: function (code) {
          hljs.configure({
            languages: [
              'python'
            ],
            tabReplace: '  ',
          })
          return hljs.highlightAuto(code).value;
        }
      });

      this.solution = marked(solution)
    },
	}

</script>

<template>
	<div class='sample-questions' v-if="solution">
		<header v-if="isCollapsed" @click="isCollapsed = false">
      <button class='cta mobile green'>
        Show Solution
      </button>
		</header>

		<header v-else>
			Solution
		</header>

		<div class='question' v-if="!isCollapsed">
			<div class='question-container'>
				<div class='question-content'>
          <div v-html='solution' />
				</div>
			</div>
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/SampleSolution/SampleSolution.vue